/**
 * lazy-images.js
 * ---------------
 * - يحول الصور اللي تحت الـ viewport لـ native lazy loading تلقائياً
 * - يشغّل Intersection Observer على الـ animations عشان متشتغلش غير لما تبان
 * - بيضيف fetchpriority="high" على صور الـ hero (فوق الـ fold)
 */
(function () {
  'use strict';

  /* ============================================
     1. LAZY IMAGES — Native Loading
     ============================================ */
  function applyNativeLazy() {
    var viewportHeight = window.innerHeight;

    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      // الصورة فوق الـ fold أو قريبة منها — تتحمل فوراً بأولوية عالية
      var isAboveFold = rect.top < viewportHeight * 1.2;

      if (isAboveFold) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('decoding', 'sync');
        if (!img.hasAttribute('fetchpriority')) {
          img.setAttribute('fetchpriority', 'high');
        }
      } else {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
    });
  }

  /* ============================================
     2. LAZY ANIMATIONS — Intersection Observer
     ============================================ */
  function lazyAnimations() {
    if (!('IntersectionObserver' in window)) return;

    // اختار كل العناصر اللي عليها classes أنيميشن
    var animatedEls = document.querySelectorAll(
      '.animate, [data-aos], .scroll-animation, ' +
      '[class*="animation-"], .fade-in, .slide-up, .slide-in, ' +
      '[class*="scroll-"], [data-animation]'
    );

    if (!animatedEls.length) return;

    // وقّف الأنيميشن في الأول على كل العناصر
    animatedEls.forEach(function (el) {
      el.dataset.animPending = '1';
      el.style.animationPlayState = 'paused';
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            // شغّل الأنيميشن لما العنصر يبان
            el.style.animationPlayState = '';
            delete el.dataset.animPending;
            observer.unobserve(el);
          }
        });
      },
      {
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.1
      }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ============================================
     3. تشغيل بعد ما الـ DOM يجهز
     ============================================ */
  function init() {
    applyNativeLazy();
    lazyAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
